import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    headerMenu: StandardPage,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    closeMenuHandler: Function,
};

const BurgerNavSmallHeaderMenuTitle: React.FC<Props> = ({
    children,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    headerMenu,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    closeMenuHandler,
}) => {
    const theme = useTheme();

    const style = css`
        color: ${theme.colours.white};

        ${theme.breakpoints.only("md")} {
            font-size: 19px;
        }

        ${theme.breakpoints.only("sm")} {
            font-size: 18px;
        }

        ${theme.breakpoints.down("xs")} {
            font-size: 16px;
        }
    `;

    return (
        <div css={style}>{children}</div>
    );
};

export default BurgerNavSmallHeaderMenuTitle;